import { SectionHeading } from "./SectionHeading";

export const LegalSection = ({ title, children, testId }) => (
  <section className="card-ae p-6 md:p-8" data-testid={testId}>
    <h2 className="font-heading text-lg font-semibold text-deepgreen">{title}</h2>
    <div className="mt-3 space-y-2 text-sm leading-relaxed text-foreground/80">{children}</div>
  </section>
);

export const LegalPage = ({ overline, title, accent, intro, children, testId }) => (
  <div className="container-ae py-12 md:py-16" data-testid={testId}>
    <SectionHeading overline={overline} title={title} accent={accent} align="center" />
    {intro && <p className="mx-auto mt-4 max-w-3xl text-center text-sm text-muted-foreground">{intro}</p>}
    <div className="mx-auto mt-10 max-w-3xl space-y-6">{children}</div>
  </div>
);
